$(function(){ 

    setColorPickerLabel($(".salba-color-swatches").find(".color-swatch:first").data("option"));

    function setActiveSwatchSlider(mediaId, prepend){
        // update main slider
        $("[data-media-id]").removeClass("is-active");
        $(`[data-media-id="${ mediaId }"]`).addClass("is-active").prependTo(".product__media-list.slider");
        // update thumbnail slider
        $(".thumbnail-list.slider [data-target] button").removeAttr("aria-current");
        $(`.thumbnail-list.slider [data-target="${ mediaId }"]`).prependTo(".thumbnail-list.slider");
        $(`.thumbnail-list.slider [data-target="${ mediaId }"] button`).attr("aria-current", "true");
    }

    function setColorPickerLabel(name){
        if(name !== undefined){
            $(".salba-color-picker-label-name").get(0).innerHTML = name;
        }
    }

    function setVariantParameter(variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);
        console.log(variantId);
    }
    
    $(".salba-color-swatches").find("input").each(function(index,swatch){
        $(swatch).on("click", function(){
            if ($(this).next(".color-swatch").hasClass("no_featured_media")) return;
            let media_id = $(this).next(".color-swatch").data("swatch-media-id");
            let name = $(this).next(".color-swatch").data("option");
            setColorPickerLabel(name);        
            setActiveSwatchSlider(media_id);
            setVariantParameter($(this).data("variant-id"));
        });      
    })
});